module.exports = __webpack_public_path__ + "img/9th_life-skills.b66c3c9e.webp";